import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-carte-employe',
  templateUrl: './carte-employe.component.html',
  styleUrls: ['./carte-employe.component.css']
})
export class CarteEmployeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
